import { useState } from "react";
import { retryRequestProcessingStep } from "../../../api/client";
import { localtext } from "./RetryRequestPage.static";

export interface RetryNotice {
  readonly title: string;
  readonly message: string;
  readonly variant: "error" | "success";
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : localtext.DefaultErrorMessage;
}

export const useRetryRequestPage = () => {
  const [requestId, setRequestId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notice, setNotice] = useState<RetryNotice | null>(null);
  const [ticketUrl, setTicketUrl] = useState("");

  async function handleRetryRequest() {
    const trimmedRequestId = requestId.trim();

    if (!trimmedRequestId) {
      setNotice({
        title: localtext.MissingRequestIdTitle,
        message: localtext.MissingRequestIdMessage,
        variant: "error",
      });
      return;
    }

    setIsSubmitting(true);
    setNotice(null);

    try {
      const response = await retryRequestProcessingStep({
        request_id: trimmedRequestId,
      });
      setNotice({
        title: localtext.RequestSubmittedTitle,
        message: response.message,
        variant: "success",
      });
    } catch (error) {
      setNotice({
        title: localtext.RequestFailedTitle,
        message: errorMessage(error),
        variant: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return {
    handleRetryRequest,
    isSubmitting,
    notice,
    requestId,
    setRequestId,
    setTicketUrl,
    ticketUrl,
  };
};
